(ns frontend.view.nev.kyc.tenant-kyc-profile.view
  (:require
   [basic-components.field-editor :as field-editor]
   [common.intelligence.common :as ic]
   [common.schema.entities.kyc.options :as kyc-options]
   [common.languages :as languages]
   [common.localization :as loc]
   [common.schema.entities.workspace.kyc.kyc-process :as kyc-process-schema]
   [frontend.actions.common :as common-actions]
   [frontend.actions.entity :as entity-actions]
   [frontend.actions.kyc-profile :as kyc-actions]
   [frontend.db :as app-db]
   [frontend.logging :as logging]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.entity-viewers.components :as nev-components]
   [frontend.view.entity-viewers.entity-editor :as entity-editor]
   [frontend.view.entity-viewers.event-pane :as event-pane]
   [frontend.view.entity-viewers.modules :as modules]
   [frontend.view.entity-viewers.utils :as entity-utils]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.nev.events :as nev-events]
   [frontend.view.nev.kyc.tenant-kyc-profile.events :as events]
   [frontend.view.not-found :as not-found]
   [frontend.view.syncing-data :as syncing]
   [frontend.zap-time :as zap-time]
   [reagent.core :as r]
   [ui.components.button.view :as button]))

(defn toolbar-buttons
  [{:keys [entity]}]
  (let [_tenant @session/tenant
        entity-id (:db/id entity)
        flagged? (contains? (:account/flagged-entities @session/account)
                            entity-id)]
    (concat
     [(zap-toolbar/dropdown-button
       {:icon      :fa-star
        :on-select (partial common-actions/toggle-flag entity flagged?)
        :ord       1
        :label     (loc/tr (if flagged? :unflag-entity-menu-item :flag-entity-menu-item))})]
     #_(when-not (session/is-read-only-user?)
         [(zap-toolbar/dropdown-button
           {:icon      :fa-cog
            :on-select events/configure-KYC-categories
            :ord       2
            :label     (loc/tr :configure-kyc-categories)})])
     (when-not (:common/disabled? entity)
       [(zap-toolbar/delete-button entity [:tenant-kyc-grid])])

     [(nev-components/audit-trail-button {:entity     entity
                                          :entity-ids [entity-id]})])))

(defn refresh-screening-status
  [kyc-profile-id state-atom]
  (swap! state-atom dissoc :loaded? :active? :reason :error?)
  (kyc-actions/*->get-screening-statuses
   {:kyc-profile-ids [kyc-profile-id]}
   (fn [response]
     (let [{:keys [active? reason]} (-> response
                                        :body
                                        :statuses
                                        (get kyc-profile-id))]
       (swap! state-atom assoc :loaded? true :active? active? :reason reason)))
   (fn [error]
     (swap! state-atom assoc :error? true)
     (js/console.log "Error while getting screening status " error))))

(defn change-screening-status!
  [new-value entity on-cancel screening-state-atom]
  (let [info-text
        (case new-value
          :screening-status/auto (loc/tr :screening-status-change-auto-desc)
          :screening-status/enforced (loc/tr :screening-status-change-enforced-desc)
          :screening-status/suspended (loc/tr :screening-status-change-suspended-desc))]
    (modals/open-modal!
     confirmation-modal/modal-key
     {:body           [:div
                       [:span (loc/tr :screening-status-changing-to)]
                       [:b (str (loc/tr new-value) ". ")]
                       [:span info-text]]
      :confirm-text   "Change screening status"
      :confirm-icon   ""
      :skip-checkbox? true
      :on-confirm     #(entity-actions/optimistic-field-update
                        (:db/id entity)
                        :tenant-kyc-profile/screening-status
                        new-value
                        session/entities
                        (fn []
                          (refresh-screening-status (:db/id entity) screening-state-atom))
                        (fn [err]
                          (logging/error "Failed to update Screening status: "
                                         err)))
      :on-cancel      on-cancel})))

(defn kyc-status-expiry
  [{:keys [entity entity-atom]}]
  (let [_tenant @session/tenant
        _tenant-schema @session/tenant-schema
        approval-date (:tenant-kyc-profile/approval-date entity)
        ;calculated-deadline (fu/get-value tenant tenant-schema entity :tenant-kyc-profile/calculated-deadline)
        expires 0                                                                                   ;(or calculated-deadline 0)
        expires-interval-str (zap-time/long->interval-str (- expires (zap-time/now)))
        documents-valid-until (or (:tenant-kyc-profile/documents-valid-until entity) 0)
        docs-valid-interval-str (zap-time/long->interval-str (- documents-valid-until
                                                                (zap-time/now)))]
    [:div.d-flex.flex-wrap.pl-2.pt-2.pb-3.entity-module
     [:div.d-flex.align-items-center.px-3.mb-3
      [:label.input-editor__label.mr-4
       (str (loc/tr :tenant-kyc-profile/status) " : ")]
      [:span.aggregate-value.aggregate-value--badge
       (->> entity
            :tenant-kyc-profile/status
            (kyc-options/label))]]
     [field-editor/view
      {:editor/type :editor.type/date
       :draggable?  false
       :class-name  "mb-3 w-auto mr-4"
       :value       approval-date
       :state-atom  entity-atom
       :attribute   :tenant-kyc-profile/approval-date
       :label       (loc/tr :tenant-kyc-profile/approval-date)
       :clearable?  false
       :read-only?  (session/is-read-only-user?)
       :on-save!    (fn [_attribute new-value]
                      (modals/open-modal!
                       confirmation-modal/modal-key
                       {:body           (loc/tr :update-approval-date-confirm-text)
                        :confirm-text   (loc/tr :update-approval-date)
                        :confirm-icon   ""
                        :skip-checkbox? true
                        :on-confirm     #(entity-actions/optimistic-field-update
                                          (:db/id entity)
                                          :tenant-kyc-profile/approval-date
                                          new-value
                                          session/entities
                                          (constantly nil)
                                          (fn [err]
                                            (logging/error "Failed to update Approval date : "
                                                           err)))}))}]
     #_[field-editor/view
        {:editor/type :editor.type/date
         :draggable?  false
         :class-name  "mb-3 w-auto"
         :value       calculated-deadline
         :read-only?  true
         :state-atom  entity-atom
         :attribute   :tenant-kyc-profile/calculated-deadline
         :label       (loc/tr :tenant-kyc-profile/calculated-deadline)
         :clearable?  false}]

     (do
       (when (> expires 0)
         [:div.ml-5.d-flex.align-items-center
          [:label.field-editor__content__header__label__text-content.mr-3
           (str (loc/tr :tenant-kyc-profile/next-deadline) " : ")]
          [:span
           {:class-name (fu/cs "aggregate-value"
                               (when (and expires (< expires (zap-time/now)))
                                 "salmon"))}
           (case (:tenant-kyc-profile/status entity)
             :kyc-status/not-started "-"
             :kyc-status/missing "-"
             :kyc-status/expired expires-interval-str
             :kyc-status/valid expires-interval-str
             :kyc-status/valid-with-expired-docs expires-interval-str)]])
       (when (> documents-valid-until 0)
         [:div.ml-5.d-flex.align-items-center
          [:label.field-editor__content__header__label__text-content.mr-3
           (str (loc/tr :kyc-documents-validity) " : ")]
          [:span
           {:class-name (fu/cs "aggregate-value"
                               (when (and documents-valid-until
                                          (< documents-valid-until (zap-time/now)))
                                 "salmon"))}
           docs-valid-interval-str]]))]))

(defn kyc-processes
  [{:keys [entity]}]
  (let [processes (->> entity
                       :tenant-kyc-profile/kyc-processes
                       (keep (partial get @session/entities)))]
    [:div
     (when-not (session/is-read-only-user?)
       [:div.row.pl-3.pt-2
        (if-not (number? (:tenant-kyc-profile/their-kyc-contact entity))
          (fu/tooltip (loc/tr :please-select-their-kyc-contact)
                      [:div.disabled-button
                       (loc/tr :add- [(loc/tr :entity.type/kyc-process)])])
          [button/primary-solid
           {:disabled? (not (number? (:tenant-kyc-profile/their-kyc-contact entity)))
            :on-click  (partial events/create-process! {:entity entity})}
           (loc/tr :add- [(loc/tr :entity.type/kyc-process)])])])
     (when (seq processes)
       [:div.row.pl-3.py-3
        [:div.table-responsive
         [:table.zap-table.zap-table--striped
          {:style {:width "100%"}}
          [:thead.zap-table__head
           [:tr.zap-table__row
            [:th.zap-table__headline (loc/tr :kyc-process/status)]
            [:th.zap-table__headline (loc/tr :kyc-process/template)]
            [:th.zap-table__headline (loc/tr :kyc-process/language)]
            [:th.zap-table__headline (loc/tr :kyc-process/invitee-email)]
            [:th.zap-table__headline (loc/tr :kyc-process/invitee-phone)]
            [:th.zap-table__headline (loc/tr :common/created-on)]
            [:th.zap-table__headline (loc/tr :common/updated-on)]]]
          [:tbody.zap-table__body
           (->>
            processes
            (sort-by :common/created-on)
            (reverse)
            (map-indexed
             (fn [_idx kyc-process]
               [:tr
                {:key        (str "KYC-process-" (:db/id kyc-process)
                                  "-" (pr-str (:kyc-process/status kyc-process)))
                 :class-name (fu/cs "zap-table__row" (pr-str (:kyc-process/status kyc-process)))
                 :on-click   (fn [_]
                               (when-not (session/is-read-only-user?)
                                 (routing/open-entity (:db/id kyc-process))))}
                [:td.zap-table__cell (kyc-options/process-status-label (:kyc-process/status kyc-process))]
                [:td.zap-table__cell
                 (kyc-process-schema/template-label (:kyc-process/template kyc-process))]
                [:td.zap-table__cell (languages/get-label (:kyc-process/language kyc-process))]
                [:td.zap-table__cell (:kyc-process/invitee-email kyc-process)]
                [:td.zap-table__cell (:kyc-process/invitee-phone kyc-process)]
                [:td.zap-table__cell (fu/format-date-ts (:common/created-on kyc-process))]
                [:td.zap-table__cell (fu/format-date-ts (:common/updated-on kyc-process))]]))
            (doall))]]]])]))

(defn kyc-profile-view
  [{:keys [kyc-profile-id]}]
  (let [state-atom (r/cursor app-db/app-state [:views :nev :tenant-kyc-profile])
        initialized? (r/atom false)
        temp-atom (r/cursor state-atom [:temp])
        screening-state-atom (r/atom nil)
        view-state-atom (r/cursor state-atom [:view-state])
        error-atom (r/cursor state-atom [:error])
        notification-atom (r/cursor state-atom [:notification])
        events-pane-atom (r/cursor state-atom [:events-pane])
        entity-atom (r/cursor session/entities [kyc-profile-id])]
    (r/create-class
     {:component-did-update
      (partial entity-utils/component-did-update
               :kyc-profile-id
               (partial nev-events/clear-errors! error-atom notification-atom))
      :component-did-mount
      (fn [_]
        (entity-utils/reset-state! state-atom kyc-profile-id
                                   {:always-fetch? (session/new-grid-2023?)})
        (reset! initialized? true)

        (when (session/screening?)
          (refresh-screening-status kyc-profile-id screening-state-atom)))

      :component-will-unmount
      (fn [_]
        (nev-events/clear-errors! error-atom notification-atom)
        (entity-utils/clear-state! state-atom))
      :reagent-render
      (fn [{:keys [kyc-profile-id] :as view-args}]
        (let [kyc-profile (get @session/entities kyc-profile-id)
              enriched-entity (ic/enrich-entity kyc-profile)]
          (cond
            (and @initialized?
                 (or (:common/disabled? kyc-profile)
                     (:not-found @state-atom)))
            [not-found/not-found-content]
            (or (not @initialized?)
                (:loading @state-atom))
            [syncing/view]
            :else
            (if (or (not kyc-profile)
                    (:common/disabled? kyc-profile))
              [:div " "]
              (let [header-rows [[:tenant-kyc-profile/our-kyc-contact :tenant-kyc-profile/their-kyc-contact]
                                 [:tenant-kyc-profile/tax-countries :kyc-profile/risk-category]
                                 [:tenant-kyc-profile/ubo-validation :tenant-kyc-profile/kyc-country]
                                 [:tenant-kyc-profile/investor-classification :tenant-kyc-profile/blocked]]
                    entity-template (entity-editor/resolve-template
                                     {:entity                @entity-atom
                                      :tenant-schema         @session/tenant-schema
                                      :account               @session/account
                                      :role                  @session/role
                                      :pipeline-id           nil
                                      :remove-fields         []
                                      :override-editor-types nil})
                    entity-template-lookup (->> entity-template
                                                (map (fn [field-schema]
                                                       [(:attribute field-schema)
                                                        field-schema]))
                                                (into {}))
                    view-id :kyc-profile
                    _module-collapsed-path (fn [module-id]
                                             [view-id :modules :module-config module-id
                                              :collapsed?])]
                [:<>
                 (when-not (session/is-guest?)
                   [zap-toolbar/view state-atom
                    (partial zap-toolbar/toolbar-back [:tenant-kyc-grid] (loc/tr :back-to/tenant-kyc-grid))
                    nil
                    (toolbar-buttons (assoc view-args
                                            :entity
                                            kyc-profile))])
                 [:div.entity__container
                  (when @error-atom
                    [nev-components/error-bar error-atom])
                  (when @notification-atom
                    [nev-components/notification-bar notification-atom])

                  [:div.entity
                   [:div
                    {:class-name "p-4 w-full max-w-[1920px] mx-auto"}

                    [kyc-status-expiry
                     {:component-state      temp-atom
                      :view-state           view-state-atom
                      :entity               kyc-profile
                      :enriched-entity      enriched-entity
                      :entity-atom          entity-atom
                      :screening-state-atom screening-state-atom}]

                    [nev-components/header-module
                     {:component-state        temp-atom
                      :view-state             view-state-atom
                      :entity                 kyc-profile
                      :enriched-entity        enriched-entity
                      :entity-atom            entity-atom
                      :entity-template-lookup entity-template-lookup
                      :field-rows             header-rows}]
                    [:div
                     {:class "grid grid-cols-10 gap-4 px-4"}
                     [:div
                      {:class "col-span-10 md:col-span-5 lg:col-span-4"}
                      [kyc-processes
                       {:component-state temp-atom
                        :view-state      view-state-atom
                        :entity          kyc-profile
                        :enriched-entity enriched-entity
                        :entity-atom     entity-atom}]]
                     [:div
                      {:class "col-span-10 md:col-span-5 lg:col-span-6"}
                      [modules/view
                       {:view-id             view-id
                        :ordering            (get-in @session/view-config [view-id :modules :ordering])
                        :save-modules-order! (partial events/save-modules-order!
                                                      (:entity/type kyc-profile))
                        :modules             [(nev-components/attachments-module view-id
                                                                                 :kyc-profile-attachments
                                                                                 kyc-profile)]}]
                      [event-pane/view
                       {:state             events-pane-atom
                        :primary-entity-id kyc-profile-id
                        :entity-ids        [kyc-profile-id]}]]]]]]])))))})))

(defmethod routing/render-view :entity.type/tenant-kyc-profile
  [{:keys [route-params]}]
  (let [kyc-profile-id (-> route-params
                           :id
                           js/parseInt)]
    [default-page-layout/view
     {:class-name "zap-page kyc-profile"}
     ;;the key change forces rerendering of the component (and its child components)
     ^{:key (str "kyc-profile-viewer-id-" kyc-profile-id)}
     [kyc-profile-view {:kyc-profile-id kyc-profile-id}]]))
